import LinkToCallMobile from 'components/LinkToCallMobile';
import React from 'react';
import styled from 'styled-components';
import AppModal from './AppModal';
const AppModalStyled = styled(AppModal)`
	.ant-modal-content {
		.ant-modal-header {
			border-bottom: 1px solid #eeeeee;
			padding-bottom: 12px;
		}
	}
`;
export default function ModalCondition({ isShow, onClose }) {
	return (
		<AppModalStyled
			title={
				<p className='text-18px leading-20px text-black font-averta-bold text-left'>
					Điều kiện điều khoản
				</p>
			}
			footer={null}
			centered={true}
			visible={isShow}
			width={812}
			onCancel={onClose}
			maskClosable={true}
		>
			<div className='mt-9px'>
				<p className='text-008BD2 font-roboto-bold'>1. Thông báo</p> Vui lòng
				đọc kỹ các điều kiện và điều khoản dưới đây. Bằng việc truy cập vào
				trang web{' '}
				<a
					className='text-008BD2'
					href='https://mybvlife.baovietnhantho.com.vn'
				>
					https://mybvlife.baovietnhantho.com.vn
				</a>{' '}
				, Quý khách đồng ý chịu ràng buộc bởi các điều kiện và điều khoản dưới
				đây. Nếu Quý khách không đồng ý với các điều kiện và điều khoản này, xin
				vui lòng không truy cập vào Trang web.
				<p className='text-008BD2 font-roboto-bold'>2. Quyền sở hữu</p> Trang
				Web này là tài sản của Tổng Công ty Bảo Việt Nhân Thọ (dưới đây gọi tắt
				là "BVNT"), thành viên của Tập đoàn Bảo Việt.
				<p className='text-008BD2 font-roboto-bold'>3. Bản quyền</p>
				Bản quyền đối với Trang Web này, các màn hình hiển thị các Trang Web,
				thông tin và tài liệu trên đó, và cách sắp xếp của các thông tin và tài
				liệu này (“Tài Liệu”) được sở hữu bởi BVNT. Quý khách có thể tải về một
				bản sao của Tài Liệu; nếu cần cho mục đích tham khảo, Quý khách có thể
				giữ một bản sao tạm thời trên máy tính và in một bản sao Tài Liệu ra
				giấy. Quý khách cũng có thể sử dụng Tài Liệu theo cách khác theo quy
				định cho phép được thể hiện rõ trên Trang web này. Sử dụng trái phép Tài
				Liệu này có thể vi phạm luật bản quyền.
				<p className='text-008BD2 font-roboto-bold'>4. Sử dụng Tài Liệu</p>
				Tài Liệu và các điều khoản, điều kiện và các mô tả thể hiện trên Trang
				Web này có thể thay đổi.
				<p className='text-008BD2 font-roboto-bold'>5. Các liên kết</p>
				Trang Web này có thể có các liên kết tới các Trang Web được quản lý hoặc
				cung cấp bởi các đơn vị khác không thuộc BVNT. BVNT từ bỏ trách nhiệm
				đối với bất cứ thông tin, tài liệu, các sản phẩm hoặc dịch vụ được đăng
				tải hoặc cung cấp tại bất kỳ trang web nào không do BVNT cung cấp có
				liên kết với Trang web này. BVNT cũng không chịu trách nhiệm cho bất kỳ
				sai sót nào của sản phẩm hay dịch vụ nào được cung cấp hoặc quảng cáo
				tại các Trang Web đó.
				<p className='text-008BD2 font-roboto-bold'>6. Giới hạn trách nhiệm</p>
				Trong giới hạn được pháp luật cho phép, trong mọi trường hợp BVNT sẽ
				không chịu trách nhiệm đối với bất kỳ thiệt hại, mất mát nào bao gồm
				nhưng không giới hạn, những thiệt hại, mất mát hay phí tổn trực tiếp hay
				gián tiếp, đặc biệt, ngẫu nhiên hay mang tính hệ quả phát sinh có liên
				quan đến Trang Web này hoặc bất kỳ các Trang Web được liên kết nào, hay
				từ việc bất kỳ bên nào sử dụng hoặc không thể sử dụng được Trang Web này
				hoặc bất kỳ Trang Web được liên kết nào. <br />
				BVNT cam kết sẽ cung cấp dịch vụ sẵn sàng cho khách hàng sử dụng. Tuy
				nhiên, khách hàng cũng phải chấp nhận rằng, việc nâng cấp hệ thống, hệ
				thống quá tải và các trường hợp bất khả kháng khác cũng đồng nghĩa với
				việc dịch vụ không luôn luôn sẵn sàng tại mọi lúc mọi nơi.
				<p className='text-008BD2 font-roboto-bold'>7. Sử dụng</p>
				Trang Web này không nhằm phân phối đến, hoặc sử dụng bởi, bất kỳ cá nhân
				hoặc tổ chức nào tại bất kỳ vùng lãnh thổ hay quốc gia nào mà việc phân
				phối hoặc sử dụng đó là trái với pháp luật địa phương.
				<p className='text-008BD2 font-roboto-bold'>
					8. Các điều khoản bổ sung
				</p>
				Một số phần hoặc trang của Trang Web này có thể có các điều kiện và điều
				khoản riêng, là bổ sung cho những điều kiện và điều khoản này. Trong
				trường hợp xảy ra mâu thuẫn, các điều kiện và điều khoản riêng đó sẽ
				được áp dụng cho những phần hoặc trang tương ứng.
				<p className='mt-12px font-roboto-bold'>CHÍNH SÁCH BẢO MẬT</p>
				<p className='text-008BD2 font-roboto-bold'>1. Mật khẩu và đăng nhập</p>
				Để hỗ trợ quý khách có thể tra cứu được thông tin về(các) hợp đồng bảo
				hiểm, BVNT cung cấp cho quý khách thông tin tra cứu trực tuyến bao gồm:
				<br />
				<p>
					- Địa chỉ trang web:{' '}
					<a
						className='text-008BD2'
						href='https://mybvlife.baovietnhantho.com.vn'
					>
						https://mybvlife.baovietnhantho.com.vn
					</a>
				</p>
				- Tên đăng nhập
				<br />- Mật khẩu
				<p className='text-008BD2 font-roboto-bold'>2. Bảo mật tài khoản </p>
				<strong>a.</strong> Quý khách phải có trách nhiệm bảo mật và giữ gìn tên
				truy cập, mật khẩu do BVNT cấp để đảm bảo rằng chỉ có duy nhất khách
				hàng mới có quyền sử dụng dịch vụ Cổng thông tin khách hàng và cần sử
				dụng mọi biện pháp cần thiết để tránh và ngăn chặn việc sử dụng dịch vụ
				bởi những người không có thẩm quyền.
				<br />
				<strong>b.</strong> Quý khách không nên lưu mật khẩu theo bất kỳ cách
				nào mà người khác có thể nhận biết, không nên chọn mật khẩu dễ đoán biết
				như ngày sinh nhật, số điện thoại của bản thân. <br />
				<strong>c.</strong> Không đặt tùy chọn của trình duyệt web cho phép lưu
				lại tên và mật khẩu người dùng.
				<br /> <strong>d.</strong> Thoát khỏi hệ thống Cổng thông tin khách hàng
				khi không sử dụng.
				<p>
					<strong>e.</strong> Nếu quý khách nghi ngờ hoặc phát hiện rằng tên
					đăng nhập, mật khẩu bị lộ, bị mất cắp, quý khách cần lập tức thay đổi
					mật khẩu của mình. Nếu không thể tự thực hiện, quý khách có thể thông
					báo ngay cho BVNT thông qua Tổng đài Chăm sóc khách hàng{' '}
					<LinkToCallMobile className='text-008BD2' href='tel:1900558899'>
						1900 558899
					</LinkToCallMobile>{' '}
					– nhánh số 4 để được hỗ trợ.
				</p>
				<p className='text-008BD2 font-roboto-bold'>3. An toàn thông tin </p>
				<strong>a.</strong> BVNT đảm bảo bí mật thông tin liên quan đến (các)
				hợp đồng bảo hiểm và các giao dịch của khách hàng theo quy định của pháp
				luật; cam kết khả năng hoạt động liên tục của hệ thống Cổng thông tin
				khách hàng; đảm bảo tính toàn vẹn của thông tin trong quá trình xử lý,
				lưu trữ và truyền nhận giữa BVNT và khách hàng; đảm bảo xác thực và nhận
				dạng được khách hàng khi khách hàng truy cập và sử dụng dịch vụ Cổng
				thông tin khách hàng và đảm bảo áp dụng các hình thức bảo vệ khách hàng
				phù hợp khác. <br />
				<strong>b.</strong> BVNT có trách nhiệm bảo mật các thông tin cá nhân
				của khách hàng khi sử dụng dịch vụ Cổng thông tin khách hàng; BVNT không
				sử dụng thông tin khách hàng vào mục đích khác và cam kết không bán,
				tiết lộ, rò rỉ các thông tin đó.
			</div>
		</AppModalStyled>
	);
}
